import { getSearchParams } from './getSearchParams';
const initializeDebugData = () => {
  window.__DEBUG_DATA__ = {};
};
export const addToDebugData = data => {
  const {
    debug
  } = getSearchParams();
  if (debug) {
    if (!window.__DEBUG_DATA__) {
      initializeDebugData();
    }
    window.__DEBUG_DATA__ = {
      ...window.__DEBUG_DATA__,
      ...data
    };
  }
};
//# sourceMappingURL=debugging.js.map